import { singleton, inject } from "tsyringe";

// interface
import type { CommonAccountsRepository } from "@/entities/common/interface/common-accounts/domain/repository";
import type { NavigationService } from "@/shared/libs/navigation/interface";
import type { AuthenticationStore } from "@/entities/user/infrastructure/userStore";

// usecase
import { PersistStorageDeleter } from "@/features/authentication/services/usecase/_workers/PersistStorageDeleter";

@singleton()
export class AttemptLogoutUsecase {
    constructor(
        @inject("CommonAccountsRepository")
        private commonAccountsRepository: CommonAccountsRepository,
        @inject("NavigationService") private navigationService: NavigationService,
        @inject(PersistStorageDeleter) private persistStorageDeleter: PersistStorageDeleter,
    ) {}

    public execute = async (authStore: AuthenticationStore) => {
        await this.commonAccountsRepository.postUserLogout();

        authStore.resetState();
        this.persistStorageDeleter.delete();

        await new Promise((resolve) => setTimeout(resolve, 200));

        this.navigationService.navigateTo("/auth");
    };
}
